import { useMemo } from 'react';
import { hasPageAccess } from '@billx/utils';

import { useCurrentAccessRole } from './accessRoles/useCurrentAccessRole';

/**
 * Headless route access check aligned with {@link useAccessControl} / PAGE_ACCESS.
 */
export function useRouteAllowed(pageKey: string) {
  const { currentAccessRole, isLoading } = useCurrentAccessRole();

  const allowed = useMemo(() => {
    if (!pageKey) return true;
    if (!currentAccessRole?.role) return false;
    return hasPageAccess(
      currentAccessRole.role,
      currentAccessRole.subRoles ?? [],
      pageKey
    );
  }, [currentAccessRole, pageKey]);

  return { allowed, isLoading };
}
